import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReportPowerBi from 'powerbi-report-component';
import { getReportRequest, reportSelector } from '../../ducks/reports';

const Report = () => {
    const dispatch = useDispatch();

    const containerRef = useRef(null);

    let [isMobile, setIsMobile] = useState(false);

    const report = useSelector(state => reportSelector(state));

    useEffect(() => {
        dispatch(getReportRequest());
    }, []);

    useEffect(
        () => {
            if (containerRef && containerRef.current && containerRef.current.offsetWidth <= 990) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        },
        [containerRef, containerRef.current],
    );

    console.log('isMobile', isMobile);

    return (
        <div className="report-container" ref={containerRef}>
            <ReportPowerBi
                embedType="report"
                tokenType="Embed"
                accessToken={report.token}
                embedUrl={report.embedURL}
                embedId={report.reportID}
                dashboardId=""
                pageName={isMobile ? report.pageName : ''}
                extraSettings={{
                    filterPaneEnabled: !isMobile,
                    navContentPaneEnabled: !isMobile,
                    layoutType: isMobile ? 2 : 0,
                }}
                permissions="All"
                style={{
                    height: 'calc(100vh - 40px)',
                    width: '100%',
                    border: '0',
                    background: '#eee',
                }}
                onLoad={report => {}}
                onSelectData={data => {
                        console.log("ReportPowerBi-onSelectData");
                        console.log(data);
                        if(data.dataPoints.length > 0){
                            if(data.dataPoints[0].identity[0].target.table == "Меню"){
                                switch(data.dataPoints[0].identity[0].equals){
                                    case "Тарифы": {
                                        window.open("https://plus.pooling.me/dictionary/tariffs", '_blank');
                                    }
                                    case "Пользователи": {
                                        window.open("https://plus.pooling.me/users", '_blank');
                                    }
                                    case "Поставщики": {
                                        window.open("https://plus.pooling.me/dictionary/providers", '_blank');
                                    }
                                    case "Торговые сети": {
                                        window.open("https://plus.pooling.me/dictionary/clients", '_blank');
                                    }
                                    case "Транспортные компании": {
                                        window.open("https://plus.pooling.me/dictionary/transportCompanies", '_blank');
                                    }
                                }
                            }
                        }
                    }
                }
                onPageChange={data => {
                        console.log("ReportPowerBi-onPageChange");
                        console.log(data);
                    }
                }
                onTileClicked={data => {
                        console.log("ReportPowerBi-onTileClicked");
                        console.log(data);
                    }
                }
            />
        </div>
    );
};

export default Report;
